import CONFIG from '../../config';

const actions = {
  signzyDigiLockerUrl(context, params) {
    context.commit('ADD_LOG', { request: 'signzyDigiLockerUrl' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('signzyDigiLockerUrl'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'signzyDigiLockerUrl' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'signzyDigiLockerUrl' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  signzyDigilockerStatus(context, params) {
    context.commit('ADD_LOG', { request: 'signzyDigilockerStatus' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('signzyDigilockerStatus', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'signzyDigilockerStatus' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'signzyDigilockerStatus' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  signzyVideoVerification(context, params) {
    context.commit('ADD_LOG', { request: 'signzyVideoVerification' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('signzyVideoVerification', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'signzyVideoVerification' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'signzyVideoVerification' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  digiLockerSubmitDetails(context) {
    context.commit('ADD_LOG', { request: 'digiLockerSubmitDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('digiLockerSubmitDetails'), undefined, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'digiLockerSubmitDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'digiLockerSubmitDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  digiLockerKarzaOtp(context, params) {
    context.commit('ADD_LOG', { request: 'digiLockerKarzaOtp' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('digiLockerKarzaOtp'), params, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'digiLockerKarzaOtp' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'digiLockerKarzaOtp' });
          context.dispatch('resolveErrorDigiLockerKarzaOtp', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  digiLockerKarzaVerifyOtp(context, params) {
    context.commit('ADD_LOG', { request: 'digiLockerKarzaVerifyOtp' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('digiLockerKarzaVerifyOtp'), params, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'digiLockerKarzaVerifyOtp' });
          resolve(response);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'digiLockerKarzaVerifyOtp' });
          context.dispatch('resolveErrorCodeForEmanDateKyc', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v2digiLockerKarzaVerifyOtp(context, params) {
    context.commit('ADD_LOG', { request: 'v2digiLockerKarzaVerifyOtp' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('v2digiLockerKarzaVerifyOtp'), params, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v2digiLockerKarzaVerifyOtp' });
          resolve(response);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v2digiLockerKarzaVerifyOtp' });
          context.dispatch('resolveErrorCodeForEmanDateKyc', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
